import { DataBean } from "../DataBean";

export class WorkActivityType extends DataBean {

  public async getWorkActivityTypeCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityTypeCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteWorkActivityType(idworkactivitytype: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivityType_Number",
      [idworkactivitytype]
    );
  }

  public async updateWorkActivityType(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivityType_updateWorkActivityType_com.advantage.processflow.bean.WorkActivityType",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivityType",
        },
      ]
    );
  }
}
